import React from 'react'

import ChequeA4 from './ChequeA4';
import Cheque80 from './Cheque80';

function Cheque({ data = { products: [] }, printChequeRef, show = false }) {


	return (
		<>
			{(data.a4 || show) ?
				<ChequeA4 data={data} printChequeRef={printChequeRef} show={show}></ChequeA4>
				:
				<Cheque80 data={data} printChequeRef={printChequeRef} show={show}></Cheque80>
			}
		</>
	)
}

export default Cheque